<script setup lang="ts">
const modelValue = defineModel<boolean>()
</script>

<template>
  <div class="flex flex-row items-center w-full gap-3 p-4 py-6">
    <YscIconsFlashSolid
      class="text-amber-400 h-6 w-6 shrink-0"
      aria-hidden="true"
    />
    <label
      class="grow cursor-pointer"
      for="istant-booking-filter-input"
    >
      <p
        id="istant-booking-filter-label"
        for="instant-booking"
        class="font-semibold"
      >
        {{ $t('commons.instant_booking') }}
      </p>
      <p class="text-sm text-gray-500">
        {{ $t('components.app_search.filters.instant_booking_description') }}
      </p>
    </label>
    <YscInputCheckbox
      id="istant-booking-filter-input"
      v-model="modelValue"
      name="instant_booking"
      aria-labelledby="istant-booking-filter-label"
    />
  </div>
</template>
